<script lang="ts">
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../../../lib/mountFederatedSvelteComponent";

  export let activeTab: string = "overview";

  export let onTabChange: (tab: string) => void = () => {};

  let container: HTMLDivElement | null = null;
  let instance: any = null;
  let RemoteComponent: any = null;

  function mount() {
    if (!container) return;
    const doMount = (Component: any) => {
      instance = mountFederatedSvelteComponent(instance, Component, {
        target: container!,
        props: { activeTab, onTabChange },
      });
    };
    if (RemoteComponent) doMount(RemoteComponent);
    else {
      // @ts-ignore - App2 remote
      import("App2/navigationTabs")
        .then((m) => {
          RemoteComponent = m.default;
          doMount(RemoteComponent);
        })
        .catch((err) => console.warn("App2/navigationTabs not available:", err));
    }
  }

  $: if (container && !instance) mount();
  $: if (instance) instance.$set({ activeTab, onTabChange });

  onDestroy(() => {
    instance = destroySvelteComponentInstance(instance);
  });
</script>

<div bind:this={container} data-navigation-tabs-host></div>
